import React, { useCallback, useEffect, useState } from 'react';
import { useAuth, useLogin, useQueryParams, ValidatorProvider } from 'react-admin-base';
import { FormattedMessage, useIntl } from "react-intl";
import { Link } from 'react-router-dom';
import { Alert, Button, Form, FormGroup, Input, Label } from 'reactstrap';
import { Validator, LoadingButton } from "react-admin-base-bootstrap";
import Layout from '../Layout.js';
const error_messages = {
    "invalid_grant": "INVALID_PASSWORD"
};
export default function Login({ children }) {
    const [api] = useAuth();
    const login = useLogin();
    const intl = useIntl();
    const { code } = useQueryParams();
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const loginByCode = useCallback(async function () {
        if (code) {
            setLoading(true);
            try {
                await api.log_in_by_code(code, window.location.origin + login.login);
            }
            catch (e) {
                setError(e);
            }
            finally {
                setLoading(false);
            }
        }
    }, [setLoading, setError, code]);
    useEffect(function () {
        loginByCode();
    }, [loginByCode]);
    const handleSubmit = useCallback(async function (e) {
        e.preventDefault();
        if (loading)
            return false;
        setError(null);
        setLoading(true);
        try {
            await api.log_in(username, password);
        }
        catch (e) {
            console.error(e);
            const msg = error_messages[(e && e.message) || '-'];
            if (msg) {
                setError(new Error(intl.formatMessage({ id: msg })));
            }
            else {
                setError(e);
            }
        }
        finally {
            setLoading(false);
        }
    }, [username, password, error, loading, intl, error_messages]);
    if (code) {
        if (loading) {
            return React.createElement(Layout, null);
        }
    }
    return React.createElement(Layout, null,
        React.createElement(ValidatorProvider, null,
            React.createElement(Form, { onSubmit: handleSubmit },
                React.createElement("div", { className: "text-center" },
                    React.createElement("div", { className: "mb-3" },
                        React.createElement("p", { className: "text-center" },
                            React.createElement(FormattedMessage, { id: "LOGIN_HEAD" })),
                        login.register && React.createElement("p", null,
                            React.createElement(Link, { className: "text-decoration-none", to: login.register },
                                React.createElement(Button, { type: "button", color: "primary", block: true, outline: true, className: "mt-3" },
                                    React.createElement(FormattedMessage, { id: "NEW_ACCOUNT" }))))),
                    children && React.createElement("div", { className: "d-grid mb-4" },
                        React.createElement("div", { className: "auth-buttons" }, children),
                        React.createElement("span", { className: "text-muted mt-3" },
                            React.createElement(FormattedMessage, { id: "OR" })))),
                React.createElement(FormGroup, { className: "auth-form-group-custom" },
                    React.createElement("i", { className: "ri-user-2-line auti-custom-input-icon" }),
                    React.createElement(Label, null,
                        React.createElement(FormattedMessage, { id: "USERNAME" })),
                    React.createElement(Validator, { name: "username", type: "required|email" },
                        React.createElement(Input, { type: "text", value: username || '', label: "Email", onChange: a => {
                                setUsername(a.currentTarget.value);
                                setError(null);
                            }, disabled: loading, autoComplete: "username" }))),
                React.createElement(FormGroup, { className: "auth-form-group-custom mb-0" },
                    React.createElement("i", { className: "ri-lock-2-line auti-custom-input-icon" }),
                    React.createElement(Label, null,
                        React.createElement(FormattedMessage, { id: "PASSWORD" })),
                    React.createElement(Validator, { name: "password", type: "required" },
                        React.createElement(Input, { type: "password", value: password || '', label: "Email", onChange: a => {
                                setPassword(a.currentTarget.value);
                                setError(null);
                            }, disabled: loading, autoComplete: "current-password" }))),
                error && React.createElement(Alert, { color: "danger", toggle: () => setError(null) }, error.message),
                React.createElement("div", { className: "mt-4 text-center" },
                    React.createElement(LoadingButton, { type: "submit", color: "primary", loading: loading },
                        React.createElement(FormattedMessage, { id: "LOGIN" }))),
                login.reset && React.createElement("div", { className: "mt-4 text-center" },
                    React.createElement(Link, { className: "form-label-link mb-0 text-muted", to: login.reset },
                        React.createElement("i", { className: "mdi mdi-lock me-1" }),
                        React.createElement(FormattedMessage, { id: "FORGOT_PASSWORD" }))))));
}
